
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaInfoCircle, FaCalendarAlt, FaClock } from "react-icons/fa";
import axios from "axios";
import { FaTrash, FaTrashAlt } from 'react-icons/fa';

const CateringOrdersCart = ({ filteredDataProp = [], onCartUpdate }) => {
    const [displayData, setDisplayData] = useState([]);
    const [quantities, setQuantities] = useState({});
    const [subTotal, setSubTotal] = useState(0);
    const [serviceCharges, setServiceCharges] = useState(0);
    const [packingCharges, setPackingCharges] = useState(0);
    const [deliveryCharges, setDeliveryCharges] = useState(0);
    const [gstTotal, setGstTotal] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [showGSTPopup, setShowGSTPopup] = useState(false);
    const [showDateTimePopup, setShowDateTimePopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const vendorIdFromStorage = localStorage.getItem("vendorId");


    // Payment Option
    const [showPaymentOptions, setShowPaymentOptions] = useState(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
    const [selectedWalletType, setSelectedWalletType] = useState('');
    const [orderId, setOrderId] = useState(null);
    const [showPaymentData, setShowPaymentData] = useState(false);
    const [savedDetails, setSavedDetails] = useState(null);

    // Date/Time State
    const [cateringDate, setCateringDate] = useState("");
    const [cateringTime, setCateringTime] = useState("");
    const [cartId, setCartId] = useState(null);
    const [expandedItems, setExpandedItems] = useState({});

    const toggleDropdown = (itemId) => {
        setExpandedItems((prev) => ({
            ...prev,
            [itemId]: !prev[itemId],
        }));
    };

    const handleCardClick = (vendorId) => {
        localStorage.setItem("vendorId", vendorId);
        // navigate(`/Topcatringresturent/${vendorId}`);
        navigate(`/cateringHomemaamaas/${vendorId}`);
    };

    const navigate = useNavigate();

    // FIXED: Simple placeholder image function
    const getPlaceholderImage = (name) => {
        const shortName = name ? name.substring(0, 8) : 'Item';
        // Use a simple data URL that always works
        return `data:image/svg+xml;base64,${btoa(`
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
                <rect width="100" height="100" fill="#ee6521" opacity="0.1"/>
                <text x="50" y="50" font-family="Arial" font-size="12" text-anchor="middle" dominant-baseline="middle" fill="#ee6521">${shortName}</text>
            </svg>
        `)}`;
    };

    // FIXED: Safe image error handler
    const handleImageError = (e, itemName, originalSrc) => {
        console.log("🖼️ Image load failed:", originalSrc);

        // Only use placeholder if the failed image wasn't already a placeholder
        if (!originalSrc.includes('data:image/svg+xml')) {
            e.target.src = getPlaceholderImage(itemName);
        }
        e.target.onerror = null; // Prevent infinite loop
    };

    useEffect(() => {
        console.log("🔄 CateringOrdersCart received props:", filteredDataProp);
        transformCartData();
        initializeDateTime();
    }, [filteredDataProp]);

    const initializeDateTime = () => {
        console.log("🕒 Initializing date/time");

        // Check if any item has scheduled date/time from API
        let hasScheduledDateTime = false;

        if (filteredDataProp && filteredDataProp.length > 0) {
            // Look for the first item that has both date and time
            const itemWithDateTime = filteredDataProp.find(item =>
                item.cateringDate && item.cateringTime
            );

            if (itemWithDateTime) {
                console.log("🎯 Found scheduled date/time from API:",
                    itemWithDateTime.cateringDate, itemWithDateTime.cateringTime);
                setCateringDate(itemWithDateTime.cateringDate);
                setCateringTime(itemWithDateTime.cateringTime);
                hasScheduledDateTime = true;
            }

            // Get cartId from the first item
            const firstItem = filteredDataProp[0];
            if (firstItem.cartId) {
                setCartId(firstItem.cartId);
                console.log("🎯 Cart ID set from props:", firstItem.cartId);
            }
        }

        // Only set defaults if no scheduled date/time found from API
        if (!hasScheduledDateTime) {
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            const defaultDate = tomorrow.toISOString().split('T')[0];
            const defaultTime = "12:00";

            setCateringDate(defaultDate);
            setCateringTime(defaultTime);
            console.log("🔄 No scheduled time found, using default:", defaultDate, defaultTime);
        }
    };


    const transformCartData = () => {
        console.log("🔄 Transforming cart data:", filteredDataProp);

        if (!filteredDataProp || !Array.isArray(filteredDataProp) || filteredDataProp.length === 0) {
            console.log("❌ No cart data received or empty array");
            setDisplayData([]);
            calculatePrices([]);
            return;
        }
        console.log("🕒 Date/Time from API - First item:", {
            cateringDate: filteredDataProp[0]?.cateringDate,
            cateringTime: filteredDataProp[0]?.cateringTime
        });

        const transformedData = filteredDataProp.map((item, index) => {
            console.log(`📦 Processing item ${index}:`, item);

            const price = parseFloat(item.price) || 0;
            const quantity = parseInt(item.quantity) || 1;
            const totalPrice = price * quantity;

            // FIXED: Use the image that comes from CateringsCartdata
            let dishImage = item.image;

            console.log(`🖼️ Image for ${item.packageName}:`, dishImage);

            // Only use placeholder if no image exists
            if (!dishImage ||
                dishImage === "" ||
                dishImage === "null" ||
                dishImage === "undefined") {
                dishImage = getPlaceholderImage(item.packageName || item.dishName);
                console.log(`🔄 Using placeholder for: ${item.packageName}`);
            }

            const transformedItem = {
                itemId: item.packageId || `item-${index}`,
                dishName: item.packageName || item.dishName || "Catering Package",
                dishImage: dishImage,
                price: price,
                quantity: quantity,
                totalPrice: totalPrice,
                category: item.packageType || "General",
                cateringDate: item.cateringDate,
                cateringTime: item.cateringTime,
                cartId: item.cartId,
                packageId: item.packageId,
                items: item.items || []
            };

            return transformedItem;
        });

        console.log("🎯 Final transformed data with images:", transformedData);
        setDisplayData(transformedData);

        const initialQuantities = {};
        transformedData.forEach(item => {
            initialQuantities[item.itemId] = item.quantity || 1;
        });
        setQuantities(initialQuantities);

        calculatePrices(transformedData);
    };



    const calculatePrices = (items) => {
        console.log("💰 Calculating prices for:", items);

        const subTotal = items.reduce((sum, item) => sum + (item.totalPrice || 0), 0);
        const serviceCharges = subTotal * 0.01; // 1% platform fee
        const gstTotal = subTotal * 0.01;
        const grandTotal = subTotal + serviceCharges + gstTotal;

        console.log("💰 Price Calculation Results:", {
            subTotal: subTotal,
            serviceCharges: serviceCharges,
            gstTotal: gstTotal,
            grandTotal: grandTotal,
            allNumbers: !isNaN(subTotal) && !isNaN(serviceCharges) && !isNaN(gstTotal) && !isNaN(grandTotal)
        });

        // Ensure all values are numbers, not strings or null
        setSubTotal(Number(subTotal) || 0);
        setServiceCharges(Number(serviceCharges) || 0);
        setGstTotal(Number(gstTotal) || 0);
        setGrandTotal(Number(grandTotal) || 0);
    };

    const updateDateTime = async () => {
        console.log("📅 Update DateTime called with:", {
            cartId,
            cateringDate,
            cateringTime
        });

        if (!cartId || !cateringDate || !cateringTime) {
            console.error("❌ Missing required fields");
            alert("Please select both date and time");
            return;
        }

        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                alert("Please login to update date/time");
                return;
            }

            // ✅ FIXED: Send time as string instead of object
            const dateTimeData = {
                cateringDate: cateringDate,
                cateringTime: cateringTime // Just send the time string directly
            };

            console.log("📅 Making API call with corrected data:", dateTimeData);

            const response = await axios.put(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/user/${cartId}/datetime`,
                dateTimeData,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    },
                    timeout: 10000
                }
            );

            console.log("✅ Date/Time API Response:", response);

            if (response.status === 200) {
                alert("Catering date and time updated successfully!");
                setShowDateTimePopup(false);

                // Update local state
                const updatedData = displayData.map(item => ({
                    ...item,
                    cateringDate: cateringDate,
                    cateringTime: cateringTime
                }));
                setDisplayData(updatedData);

                // Refresh cart data
                if (onCartUpdate) {
                    console.log("🔄 Refreshing cart data...");
                    setTimeout(() => {
                        onCartUpdate();
                    }, 1000);
                }
            }

        } catch (error) {
            console.error("❌ Error updating date/time:", error);
            // ... your existing error handling
        }
    };

    const incrementQuantity = async (item) => {
        const newQuantity = (quantities[item.itemId] || 0) + 1;
        setQuantities(prev => ({ ...prev, [item.itemId]: newQuantity }));

        // Update via API
        await updateCartQuantityAPI(item.cartId, item.packageId, newQuantity);
    };

    const decrementQuantity = async (item) => {
        const currentQty = quantities[item.itemId] || 0;
        if (currentQty <= 1) return;
        const newQuantity = currentQty - 1;
        setQuantities(prev => ({ ...prev, [item.itemId]: newQuantity }));

        // Update via API
        await updateCartQuantityAPI(item.cartId, item.packageId, newQuantity);
    };

    // API call to update quantity
    const updateCartQuantityAPI = async (cartId, packageId, newQuantity) => {
        try {
            const token = localStorage.getItem("authToken");

            if (!token) {
                alert("Please login to manage cart");
                return;
            }

            console.log("🔄 Updating quantity via API:", { cartId, packageId, newQuantity });

            const response = await axios.put(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/user/updatequantity/${cartId}`,
                {
                    quantity: newQuantity,
                    packageId: packageId
                },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            console.log("✅ Quantity updated via API:", response.data);

            // Update localStorage as fallback
            updateCartQuantityLocal(packageId, newQuantity);

            // Refresh cart data
            if (onCartUpdate) {
                onCartUpdate();
            }

        } catch (error) {
            console.error("❌ Error updating quantity via API:", error);
            // Fallback to localStorage
            updateCartQuantityLocal(packageId, newQuantity);
            alert("Quantity updated locally (API update failed)");
        }
    };

    // Fallback to localStorage update
    const updateCartQuantityLocal = (packageId, newQuantity) => {
        const existingCart = JSON.parse(localStorage.getItem('cateringCart') || '[]');
        const updatedCart = existingCart.map(item =>
            item.packageId === packageId
                ? { ...item, quantity: newQuantity }
                : item
        );
        localStorage.setItem('cateringCart', JSON.stringify(updatedCart));

        // Recalculate prices
        transformCartData();
    };

    const removeItem = async (item) => {
        try {
            const token = localStorage.getItem("authToken");

            if (!token) {
                alert("Please login to manage cart");
                return;
            }

            console.log("🗑️ Removing item via API:", { cartId: item.cartId, packageId: item.packageId });

            // API call to remove item
            const response = await axios.delete(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/user/package/${item.packageId}/${item.cartId}`,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            console.log("✅ Item removed via API:", response.data);

            // Update localStorage
            removeItemLocal(item.itemId);

            // Refresh cart data
            if (onCartUpdate) {
                onCartUpdate();
            }

        } catch (error) {
            console.error("❌ Error removing item via API:", error);
            // Fallback to localStorage
            removeItemLocal(item.itemId);
            alert("Item removed locally (API removal failed)");
        }
    };

    const removeItemLocal = (itemId) => {
        const existingCart = JSON.parse(localStorage.getItem('cateringCart') || '[]');
        const updatedCart = existingCart.filter(item => item.packageId !== itemId);
        localStorage.setItem('cateringCart', JSON.stringify(updatedCart));

        // Update display
        const updatedData = displayData.filter(item => item.itemId !== itemId);
        setDisplayData(updatedData);
        calculatePrices(updatedData);
    };

    const handleClearCart = async () => {
        if (window.confirm("Clear all catering items?")) {
            setLoading(true);
            try {
                // Remove all items via API
                const token = localStorage.getItem("authToken");
                const userId = localStorage.getItem("userId");

                if (token && userId) {
                    // Get current cart to find all cartIds
                    const cartResponse = await axios.get(
                        `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/user/cart/${userId}`,
                        {
                            headers: {
                                "Authorization": `Bearer ${token}`,
                                "Content-Type": "application/json"
                            }
                        }
                    );

                    // Remove all items from all carts
                    if (cartResponse.data && Array.isArray(cartResponse.data)) {
                        for (const order of cartResponse.data) {
                            if (order.items && Array.isArray(order.items)) {
                                for (const item of order.items) {
                                    await axios.delete(
                                        `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/user/package/${item.packageId}/${order.id}`,
                                        {
                                            headers: {
                                                "Authorization": `Bearer ${token}`,
                                                "Content-Type": "application/json"
                                            }
                                        }
                                    );
                                }
                            }
                        }
                    }
                }

                // Clear localStorage
                localStorage.setItem('cateringCart', JSON.stringify([]));
                setDisplayData([]);
                setQuantities({});
                calculatePrices([]);

                // Refresh cart data
                if (onCartUpdate) {
                    onCartUpdate();
                }

            } catch (error) {
                console.error("❌ Error clearing cart via API:", error);
                // Fallback to localStorage clear
                localStorage.setItem('cateringCart', JSON.stringify([]));
                setDisplayData([]);
                setQuantities({});
                calculatePrices([]);
            } finally {
                setLoading(false);
            }
        }
    };

    // ----------------  Payment Option -------------------------

    const handlePlaceOrder = () => {
        if (displayData.length === 0) {
            alert("Your catering cart is empty!");
            return;
        }

        if (!cateringDate || !cateringTime) {
            alert("Please select catering date and time before proceeding");
            return;
        }

        // Show payment options popup instead of navigating directly
        setShowPaymentOptions(true);
        setSelectedPaymentMethod('');
    };

    const handlePaymentSelect = (paymentMethod) => {
        setSelectedPaymentMethod(paymentMethod);
    };

    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = 'https://checkout.razorpay.com/v1/checkout.js';
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    // const walletTypeMap = {
    //     SELF_LOADED: "SELF_LOADED",
    //     // Add other wallet types if needed
    // };
    const walletTypeMap = {
        self: "SELF_LOADED",
        company: "COMPANY_LOADED",
        cashback: "CASHBACK"
    };
    const tryAlternativeFormat = async () => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");
        const mappedWalletType = walletTypeMap[selectedWalletType];

        console.log("🔄 TRYING ALTERNATIVE FORMAT...");

        // Try the exact format that worked in Swagger
        const alternativeBody = {
            walletType: mappedWalletType || "SELF_LOADED",
            total: Number(grandTotal), // Just send as number without toFixed
            cateringDate: cateringDate,
            cateringTime: cateringTime
        };

        console.log("🔄 ALTERNATIVE BODY:", alternativeBody);

        try {
            const response = await fetch(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/user/orders?cartId=${cartId}&userId=${userId}&paymentMethod=${selectedPaymentMethod}`,
                {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(alternativeBody)
                }
            );

            const result = await response.json();
            console.log("🔄 ALTERNATIVE RESULT:", result);

            if (response.ok) {
                if (result?.orderId) {
                    localStorage.setItem("orderId", result.orderId);
                    setOrderId(result.orderId);
                }
                setShowPaymentData(true);
                alert("✅ Order placed successfully!");
            } else {
                console.log("❌ Alternative also failed:", result);
            }
        } catch (altError) {
            console.error("❌ Alternative approach failed:", altError);
        }
    };

    const handleCheckoutClick = async () => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken"); // ✅ get stored token
        const mappedWalletType = walletTypeMap[selectedWalletType];

        console.log("Selected Wallet Type (Mapped):", mappedWalletType);

        if (!userId) {
            alert("User ID not found. Please log in again.");
            return;
        }

        if (selectedPaymentMethod === "Maamaas_Wallet" && !selectedWalletType) {
            alert("Please select a wallet type before creating the order.");
            return;
        }

        try {
            console.log("✅ ENTERING TRY BLOCK - Making API call...");
            localStorage.removeItem("orderId");

            // ----------------- ONLINE PAYMENT -----------------
            if (selectedPaymentMethod === "Online_Payment") {
                const isRazorpayLoaded = await loadRazorpayScript();
                if (!isRazorpayLoaded) {
                    alert("❌ Razorpay SDK failed to load.");
                    return;
                }

                const amountInPaise = Math.round(grandTotal);
                const username = 'rzp_live_RU5whSMu9rPV7s';
                const password = 'FjLrs51Gf8Yq5OWT22CqamGF';
                const basicAuth = btoa(`${username}:${password}`);

                // Step 1: Create Razorpay order in backend
                const orderResponse = await fetch(
                    "http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/payments/create-order/user",
                    {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Basic ${basicAuth}`,
                        },
                        body: JSON.stringify({
                            amount: amountInPaise,
                            currency: "INR",
                            receipt: `order_${Date.now()}`,
                            notes: {
                                customer_name: savedDetails?.name || "John Doe",
                                order_reference: `WEB_ORDER_${Math.floor(Math.random() * 10000)}`,
                            },
                            partial_payment: false,
                            payment_capture: 0
                        }),
                    }
                );

                if (!orderResponse.ok) throw new Error("❌ Failed to create Razorpay order");
                const orderData = await orderResponse.json();
                console.log("🆔 Razorpay Order Created:", orderData);

                // Step 2: Open Razorpay checkout
                const options = {
                    key: "rzp_live_RU5whSMu9rPV7s",
                    amount: amountInPaise,
                    currency: "INR",
                    order_id: orderData.id || orderData.orderId,
                    name: "Maamaa's House",
                    description: "Order Payment",
                    prefill: {
                        name: savedDetails?.name || "Vamshi",
                        email: savedDetails?.email || "vamshikvky500@gmail.com",
                        contact: savedDetails?.mobileNumber || "9652030425",
                    },
                    theme: { color: "#3399cc" },
                    handler: async function (response) {
                        try {
                            console.log("✅ Payment Success Response:", response);

                            // Step 3: Capture Razorpay Payment
                            const captureRes = await fetch(
                                'http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/payments/capture',
                                {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({
                                        paymentId: response.razorpay_payment_id,
                                        amount: amountInPaise,
                                        currency: "INR",
                                        orderId: orderData.id || orderData.orderId,
                                    }),
                                }
                            );

                            const rawText = await captureRes.text();
                            let captureData;
                            try {
                                captureData = JSON.parse(rawText);
                            } catch {
                                captureData = { raw: rawText };
                            }

                            if (!captureRes.ok) throw new Error("❌ Payment capture failed");
                            console.log("✅ Payment captured successfully!", captureData);

                            // Step 4: Place Scheduled Order with token
                            const token = localStorage.getItem("authToken"); // 🔐 get stored token
                            const responseOrder = await axios.post(
                                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/user/orders?cartId=${cartId}&userId=${userId}&paymentMethod=${selectedPaymentMethod}`,
                                {
                                    cateringDate: cateringDate,
                                    cateringTime: cateringTime,
                                    razorpayPaymentId: response.razorpay_payment_id,
                                    razorpayOrderId: response.razorpay_order_id,
                                    walletType: mappedWalletType || "SELF_LOADED",
                                    subtotal: parseFloat(subTotal.toFixed(2)),
                                    gstAmount: parseFloat(gstTotal.toFixed(2)),
                                    platformFeeAmount: parseFloat(serviceCharges.toFixed(2)),
                                    grandTotal: parseFloat(grandTotal.toFixed(2)),
                                    amountPaid: parseFloat(grandTotal.toFixed(2))
                                },
                                {
                                    headers: {
                                        Authorization: `Bearer ${token}`,
                                        "Content-Type": "application/json",
                                        Accept: "*/*",
                                    },
                                }
                            );

                            if (responseOrder.data?.token) {
                                localStorage.setItem("authToken", responseOrder.data.token);
                                console.log("🔐 Token updated in localStorage:", responseOrder.data.token);
                            }

                            if (responseOrder.status === 200 || responseOrder.status === 201) {
                                const newOrderId = responseOrder.data.orderId;
                                if (newOrderId) {
                                    localStorage.setItem("orderId", newOrderId);
                                    setOrderId(newOrderId);
                                }
                                setShowPaymentData(true);
                            } else {
                                alert("❌ Payment captured but order creation failed!");
                            }

                        } catch (err) {
                            console.error("❌ Error after payment:", err);
                            alert("❌ Payment succeeded but order failed.");
                        }
                    },
                };

                const paymentObject = new window.Razorpay(options);
                paymentObject.open();
                return;
            }

            // ----------------- OFFLINE / WALLET PAYMENT -----------------
            const sentData = {
                walletType: mappedWalletType || "SELF_LOADED",
                grandTotal: parseFloat(grandTotal.toFixed(2)), // ✅ FIXED: Send 'grandTotal' instead of 'total'
                cateringDate: cateringDate,
                cateringTime: cateringTime
            };

            alert("📦 Sending this data to backend:\n" + JSON.stringify(sentData, null, 2)); // ✅ SHOW IN ALERT

            const orderResponse = await axios.post(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/user/orders?cartId=${cartId}&userId=${userId}&paymentMethod=${selectedPaymentMethod}`,
                sentData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (orderResponse.data?.token) {
                localStorage.setItem("authToken", orderResponse.data.token);
                console.log("🔐 Token updated in localStorage:", orderResponse.data.token);
            }

            console.log("Order API Response:", orderResponse.data);

            if (orderResponse.status === 200 || orderResponse.status === 201) {
                if (orderResponse.data?.orderId) {
                    localStorage.setItem("orderId", orderResponse.data.orderId);
                    setOrderId(orderResponse.data.orderId);
                }
                setShowPaymentData(true);
            } else {
                alert("⚠️ Failed to create order.");
            }

        } catch (error) {
            console.error("🔴 FULL ERROR DETAILS:", {
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data,
                message: error.message
            });

            console.log("🔴 ACTUAL REQUEST SENT:", {
                url: `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/user/orders?cartId=${cartId}&userId=${userId}&paymentMethod=${selectedPaymentMethod}`,
                body: {
                    walletType: mappedWalletType || "SELF_LOADED",
                    grandTotal: parseFloat(grandTotal.toFixed(2)),
                    cateringDate: cateringDate,
                    cateringTime: cateringTime
                }
            });

            alert("Order creation failed. Please check console for details.");
        }
    };

    return (
        <div>
            {/* Order Review Section */}
            <div style={{
                background: "#ee6521",
                borderRadius: "10px",
                padding: "20px",
                color: "white",
                marginBottom: "20px"
            }}>
                <div style={{
                    position: "relative",
                    textAlign: "center",
                    marginBottom: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}>
                    <h4 style={{ margin: 0, fontSize: "22px", fontWeight: "600" }}>Catering Order Review</h4>
                    {/* Clear All Button */}
                    <button
                        onClick={handleClearCart}
                        disabled={loading}
                        style={{
                            color: "red",
                            background: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: loading ? "not-allowed" : "pointer",
                            padding: "8px 15px",
                            opacity: loading ? 0.6 : 1,
                            fontSize: "18px",


                        }}
                    >
                        {loading ? "Clearing..." : "Clear"}
                    </button>

                </div>

                {/* Items Table */}
                <div style={{ overflowX: "auto" }}>
                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            color: "white",
                            tableLayout: "fixed", // 👈 ensures equal column widths
                        }}
                    >
                        <thead>
                            <tr>
                                <th style={{ width: "5%", padding: "10px", textAlign: "center" }}>S.NO</th>
                                <th style={{ width: "35%", padding: "10px", textAlign: "center" }}>ITEM</th>
                                <th style={{ width: "15%", padding: "10px", textAlign: "center" }}>QTY</th>
                                <th style={{ width: "15%", padding: "10px", textAlign: "center" }}>PRICE</th>
                                <th style={{ width: "15%", padding: "10px", textAlign: "center" }}>TOTAL</th>
                                <th style={{ width: "15%", padding: "10px", textAlign: "center" }}>ACTION</th>
                            </tr>
                        </thead>

                        <tbody>
                            {displayData.length > 0 ? (
                                displayData.map((item, index) => (
                                    <tr key={item.itemId}>
                                        <td style={{ width: "5%", padding: "10px", textAlign: "center" }}>{index + 1}</td>
                                        <td
                                            style={{
                                                width: "35%",
                                                padding: "10px",
                                                textAlign: "center",
                                                fontWeight: "bold",
                                                overflow: "hidden", // prevents flex overflow
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: "6px",
                                                }}
                                                onClick={() => toggleDropdown(item.itemId)}
                                            >
                                                <div>{item.dishName}</div>
                                                <span style={{ fontSize: "12px", color: "#ccc" }}>
                                                    {expandedItems[item.itemId] ? "▲" : "▼"}
                                                </span>
                                            </div>

                                            {expandedItems[item.itemId] && item.items?.length > 0 && (
                                                <ul
                                                    style={{
                                                        listStyle: "none",
                                                        marginTop: "5px",
                                                        paddingLeft: "0px",
                                                        fontSize: "12px",
                                                        color: "#f0f0f0",
                                                        textAlign: "right", // ✅ centers the list text
                                                    }}
                                                >
                                                    {item.items.map((pkgItem, i) => (
                                                        <li
                                                            key={i}
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "center", // ✅ ensures even alignment under the parent
                                                                gap: "5px", // spacing between bullet and text
                                                            }}
                                                        >
                                                            <span style={{ color: "#999" }}>•</span>
                                                            <span>{pkgItem.itemName}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </td>

                                        <td style={{ width: "15%", padding: "10px", textAlign: "center" }}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    background: "#fff",
                                                    borderRadius: "10px",
                                                    width: "80px",
                                                    margin: "auto",
                                                    paddingLeft: "5px",
                                                }}
                                            >
                                                <button
                                                    onClick={() => decrementQuantity(item)}
                                                    disabled={loading}
                                                    style={{
                                                        border: "none",
                                                        background: "transparent",
                                                        padding: "5px",
                                                        cursor: loading ? "not-allowed" : "pointer",
                                                        color: "#000",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    -
                                                </button>
                                                <span
                                                    style={{
                                                        padding: "0px 10px",
                                                        fontWeight: "800",
                                                        color: "#000",
                                                    }}
                                                >
                                                    {quantities[item.itemId] || 0}
                                                </span>
                                                <button
                                                    onClick={() => incrementQuantity(item)}
                                                    disabled={loading}
                                                    style={{
                                                        border: "none",
                                                        background: "transparent",
                                                        padding: "5px",
                                                        cursor: loading ? "not-allowed" : "pointer",
                                                        color: "#000",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </td>

                                        <td
                                            style={{
                                                width: "15%",
                                                padding: "10px",
                                                textAlign: "center",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            ₹{item.price?.toFixed(2)}
                                        </td>

                                        <td
                                            style={{
                                                width: "15%",
                                                padding: "10px",
                                                textAlign: "center",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            ₹{item.totalPrice?.toFixed(2)}
                                        </td>

                                        <td
                                            style={{
                                                width: "15%",
                                                padding: "10px",
                                                textAlign: "center",
                                            }}
                                        >
                                            <button
                                                onClick={() => removeItem(item)}
                                                disabled={loading}
                                                style={{
                                                    background: "#ee6521",
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: "4px",
                                                    padding: "5px 10px",
                                                    cursor: loading ? "not-allowed" : "pointer",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                <FaTrash />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" style={{ padding: "20px", textAlign: "center", fontWeight: "bold" }}>
                                        No items in cart
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                </div>
            </div>

            {/* Rest of the component remains the same */}
            {/* Date/Time Popup */}
            {showDateTimePopup && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0, 0, 0, 0.6)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 999
                }}>
                    <div style={{
                        background: "white",
                        padding: "25px",
                        borderRadius: "12px",
                        width: "90%",
                        maxWidth: "400px",
                        textAlign: "center"
                    }}>
                        <h3 style={{ marginBottom: "20px", color: "#ee6521" }}>
                            <FaCalendarAlt style={{ marginRight: "10px" }} />
                            Schedule Your Catering
                        </h3>

                        <div style={{ marginBottom: "20px" }}>
                            <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold", textAlign: "left", color: "#333" }}>
                                <FaCalendarAlt style={{ marginRight: "8px" }} />
                                Catering Date *
                            </label>
                            <input
                                type="date"
                                value={cateringDate}
                                onChange={(e) => setCateringDate(e.target.value)}
                                min={new Date().toISOString().split('T')[0]}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    border: "1px solid #ddd",
                                    borderRadius: "6px",
                                    fontSize: "16px"
                                }}
                                required
                            />
                        </div>

                        <div style={{ marginBottom: "25px" }}>
                            <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold", textAlign: "left", color: "#333" }}>
                                <FaClock style={{ marginRight: "8px" }} />
                                Catering Time *
                            </label>
                            <input
                                type="time"
                                value={cateringTime}
                                onChange={(e) => setCateringTime(e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    border: "1px solid #ddd",
                                    borderRadius: "6px",
                                    fontSize: "16px"
                                }}
                                required
                            />
                        </div>

                        {cartId && (
                            <div style={{ marginBottom: "15px", fontSize: "12px", color: "#666", textAlign: "center" }}>
                                {/* Cart ID: {cartId} */}
                            </div>
                        )}

                        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                            <button
                                onClick={() => setShowDateTimePopup(false)}
                                style={{
                                    padding: "10px 20px",
                                    background: "#ccc",
                                    color: "#333",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    fontSize: "14px"
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={updateDateTime}
                                disabled={!cateringDate || !cateringTime || !cartId}
                                style={{
                                    padding: "10px 20px",
                                    background: (!cateringDate || !cateringTime || !cartId) ? "#ccc" : "#ee6521",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: (!cateringDate || !cateringTime || !cartId) ? "not-allowed" : "pointer",
                                    fontSize: "14px"
                                }}
                            >
                                Update Schedule
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {/* Pricing Summary */}
            <div style={{ background: "#ee6521", borderRadius: "10px", padding: "20px", color: "white" }}>
                <div style={{ maxWidth: "300px", marginLeft: "auto" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                        <span>Sub Total</span>
                        <span>₹{subTotal.toFixed(2)}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                        <span>GST (1%)</span>
                        <span>₹{gstTotal.toFixed(2)}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                        <span>Platform Fee</span>
                        <span>₹{serviceCharges.toFixed(2)}</span>
                    </div>
                </div>
                <hr style={{ border: "1px solid #fff", margin: "15px 0" }} />
                <div style={{ maxWidth: "300px", marginLeft: "auto" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "20px", fontWeight: "bold" }}>
                        <span>Grand Total</span>
                        <span>₹{grandTotal.toFixed(2)}</span>
                    </div>
                </div>
            </div>

            {/* Action Buttons */}
            <div style={{ textAlign: "center", marginTop: "30px" }}>
                <div style={{
                    display: "flex",
                    gap: "15px",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "wrap"
                }}>
                    {/* Schedule Button */}
                    <button
                        onClick={() => setShowDateTimePopup(true)}
                        style={{
                            background: "#fff",
                            color: "#ee6521",
                            border: "2px solid #ee6521",
                            borderRadius: "10px",
                            padding: "12px 20px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            minWidth: "140px",
                            justifyContent: "center"
                        }}
                    >
                        <FaCalendarAlt />
                        {cateringDate && cateringTime ? (
                            <>
                                {new Date(cateringDate).toLocaleDateString('en-US', {
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric'
                                })} • {cateringTime} {parseInt(cateringTime.split(':')[0]) >= 12 ? 'PM' : 'AM'}
                            </>
                        ) : (
                            "Schedule"
                        )}
                    </button>

                    {/* Add More Items Button */}

                    <button
                        // onClick={() => handleCardClick(yourVendorId)}
                        onClick={() => handleCardClick(vendorIdFromStorage)}
                        style={{
                            background: "#ee6521",
                            color: "white",
                            border: "2px solid #ee6521",
                            borderRadius: "10px",
                            padding: "12px 20px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            minWidth: "140px"
                        }}
                    >
                        Add More Items
                    </button>

                    {/* Proceed Button */}
                    <button
                        onClick={handlePlaceOrder}
                        disabled={displayData.length === 0 || loading || !cateringDate || !cateringTime}
                        style={{
                            background: (displayData.length === 0 || !cateringDate || !cateringTime) ? "#ccc" : "#ee6521",
                            color: "white",
                            border: (displayData.length === 0 || !cateringDate || !cateringTime) ? "2px solid #ccc" : "2px solid #ee6521",
                            borderRadius: "10px",
                            padding: "12px 20px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            cursor: (displayData.length === 0 || !cateringDate || !cateringTime) ? "not-allowed" : "pointer",
                            minWidth: "200px",
                            opacity: loading ? 0.6 : 1
                        }}
                    >
                        {loading ? "Processing..." : "Proceed to CheckOut"}
                    </button>
                </div>
            </div>

            {/* Payment Options Section - Hidden by default, shows when Proceed to Checkout is clicked */}
            {/* Payment Options Section - Hidden by default, shows when Proceed to Checkout is clicked */}
            {showPaymentOptions && (
                <div style={{
                    background: "#f8f0ff",
                    borderRadius: "10px",
                    padding: "25px",
                    marginTop: "20px",
                    border: "2px solid #ee6521",
                    boxShadow: "0 4px 12px rgba(177, 92, 214, 0.2)"
                }}>
                    <h4 style={{ textAlign: "center", marginBottom: "25px", color: "#ee6521", fontSize: "20px" }}>
                        Select Payment Method
                    </h4>

                    <div style={{
                        display: "flex",
                        gap: "20px",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        marginBottom: "25px"
                    }}>
                        {/* Wallet Payment Option */}
                        <div
                            onClick={() => handlePaymentSelect('Maamaas_Wallet')}
                            style={{
                                padding: "20px 25px",
                                border: selectedPaymentMethod === 'Maamaas_Wallet' ? "2px solid #ee6521" : "2px solid #ddd",
                                borderRadius: "10px",
                                cursor: "pointer",
                                background: selectedPaymentMethod === 'Maamaas_Wallet' ? "#f0e6f5" : "white",
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                minWidth: "180px",
                                justifyContent: "center",
                                transition: "all 0.3s ease"
                            }}
                        >
                            <div style={{
                                width: "22px",
                                height: "22px",
                                borderRadius: "50%",
                                border: selectedPaymentMethod === 'Maamaas_Wallet' ? "6px solid #ee6521" : "2px solid #ddd",
                                background: "white",
                                transition: "all 0.3s ease"
                            }}></div>
                            <span style={{ fontWeight: "bold", fontSize: "16px" }}>Wallet Payment</span>
                        </div>

                        {/* Online Payment Option */}
                        <div
                            onClick={() => handlePaymentSelect('Online_Payment')}
                            style={{
                                padding: "20px 25px",
                                border: selectedPaymentMethod === 'Online_Payment' ? "2px solid #ee6521" : "2px solid #ddd",
                                borderRadius: "10px",
                                cursor: "pointer",
                                background: selectedPaymentMethod === 'Online_Payment' ? "#f0e6f5" : "white",
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                minWidth: "180px",
                                justifyContent: "center",
                                transition: "all 0.3s ease"
                            }}
                        >
                            <div style={{
                                width: "22px",
                                height: "22px",
                                borderRadius: "50%",
                                border: selectedPaymentMethod === 'Online_Payment' ? "6px solid #ee6521" : "2px solid #ddd",
                                background: "white",
                                transition: "all 0.3s ease"
                            }}></div>
                            <span style={{ fontWeight: "bold", fontSize: "16px" }}>Online Payment</span>
                        </div>
                    </div>

                    {/* Wallet Type Selection - Only show for Wallet Payment */}
                    {/* Wallet Type Selection - Only show for Wallet Payment */}
                    {selectedPaymentMethod === 'Maamaas_Wallet' && (
                        <div style={{
                            marginBottom: "20px",
                            textAlign: "center"
                        }}>
                            <label style={{
                                display: "block",
                                marginBottom: "8px",
                                fontWeight: "bold",
                                color: "#666",
                                fontSize: "14px"
                            }}>
                                Wallet Type
                            </label>
                            <select
                                value={selectedWalletType}
                                onChange={(e) => setSelectedWalletType(e.target.value)}
                                style={{
                                    width: "200px",
                                    padding: "10px 15px",
                                    border: "2px solid #ee6521",
                                    borderRadius: "8px",
                                    fontSize: "14px",
                                    background: "white",
                                    cursor: "pointer",
                                    outline: "none"
                                }}
                            >
                                <option value="">Choose Wallet Type</option>
                                <option value="self">Self Loaded</option>
                                <option value="company">Company Loaded</option>
                                <option value="cashback">Cashback</option>
                            </select>
                        </div>
                    )}

                    {/* Confirm Order Button */}
                    <div style={{ textAlign: "center" }}>
                        <button
                            onClick={handleCheckoutClick}
                            disabled={!selectedPaymentMethod || (selectedPaymentMethod === 'Maamaas_Wallet' && !selectedWalletType)}
                            style={{
                                padding: "14px 40px",
                                background: (!selectedPaymentMethod || (selectedPaymentMethod === 'Maamaas_Wallet' && !selectedWalletType)) ? "#ccc" : "#ee6521",
                                color: "white",
                                border: "none",
                                borderRadius: "8px",
                                cursor: (!selectedPaymentMethod || (selectedPaymentMethod === 'Maamaas_Wallet' && !selectedWalletType)) ? "not-allowed" : "pointer",
                                fontSize: "16px",
                                fontWeight: "bold",
                                minWidth: "220px",
                                transition: "all 0.3s ease"
                            }}
                        >
                            Confirm Order
                        </button>
                    </div>
                </div>
            )}


            {/* GST Popup */}
            {showGSTPopup && (
                <div style={{
                    position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
                    background: "rgba(0, 0, 0, 0.6)", display: "flex", alignItems: "center",
                    justifyContent: "center", zIndex: 999
                }}>
                    <div style={{
                        background: "white", padding: "25px", borderRadius: "12px",
                        width: "300px", textAlign: "center"
                    }}>
                        <h3 style={{ marginBottom: "15px" }}>GST Breakdown</h3>
                        <p>CGST (9%): ₹{(gstTotal / 2).toFixed(2)}</p>
                        <p>SGST (9%): ₹{(gstTotal / 2).toFixed(2)}</p>
                        <button
                            onClick={() => setShowGSTPopup(false)}
                            style={{
                                padding: "10px 20px", background: "#ee6521", color: "#fff",
                                border: "none", borderRadius: "6px", cursor: "pointer", marginTop: "15px"
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}


        </div>
    );
};

export default CateringOrdersCart;